import axios from 'axios'

/**
 *
 * @returns Return All Subscription Plans
 */
export const getAllSubscriptionPlans = async (country) => {
  const response = await axios.get(`plans?country=${country || 'USA'}`)
  return response
}

/**
 *
 * @returns Return All Feature Addons
 */
export const getAllFeatureAddons = async (country = null) => {
  const response = await axios.get(`credits?country=${country || 'USA'}`)
  return response
}

/**
 *
 * @returns Get all user purchase subscription
 */
export const getAllUserSubscriptions = async (contestUri = null) => {
  const response = await axios.get(
    `subscriptions${contestUri ? `?contestUri=${contestUri}` : ''}`
  )
  return response
}

/**
 *
 * @param {string} priceId
 * @param {boolean} isSubscriptionPurchase
 * @returns OrderId for Razorpay
 */
export const createRazorpayOrderId = async (
  priceId,
  planId,
  planPeriod,
  isSubscriptionPurchase,
  currency
) => {
  const payload = {
    planId,
    frequency: planPeriod,
    paymentCurrency: currency
  }

  const response = await axios.post(
    isSubscriptionPurchase
      ? 'subscriptions/create'
      : `features/order/${priceId}`,
    isSubscriptionPurchase ? payload : {}
  )
  return response
}

/**
 *
 * @param {Object} payload
 * @param {boolean} isSubscriptionPurchase
 * @returns
 */
export const purchaseSubscription = async (payload, isSubscriptionPurchase) => {
  const response = await axios.post(
    isSubscriptionPurchase
      ? `subscriptions/activate/${payload?.paymentId}`
      : 'features/purchase',
    isSubscriptionPurchase ? {} : payload
  )
  return response
}

/**
 *
 * @param {string} planId
 * @returns
 */
export const activateSubscription = async (planId) => {
  const response = await axios.post(`subscriptions/activate/${planId}`)
  return response
}

/**
 *
 * @returns Return Purchased Addon and usage
 */
export const getAllFeatureAddonPurchased = async () => {
  const response = await axios.get('credits/additional-usage')
  return response
}

/**
 *
 * @returns subscription options
 */
export const getAllSubscriptionOptions = async () => {
  const response = await axios.get(`cache/subscription-plans`)
  return response
}

/**
 *
 * @param {string} challengeTypeId
 * @returns
 */
export const getAllSubscriptionOptionsWithId = async (challengeTypeId) => {
  const response = await axios.get(
    `cache/${challengeTypeId}/subscription-plans`
  )
  return response
}

/**
 *
 * @param {string} country
 * @param {number} credits
 * @param {string} coupon
 * @returns object
 */
export const getCreditsPrice = async (country, credits, coupon) => {
  const response = await axios.get('credits/estimate-price', {
    params: {
      country,
      credits,
      coupon
    }
  })
  return response
}

/**
 *
 * @param {object} payload
 * @returns object
 */
export const validateCouponCode = async (payload) => {
  const response = await axios.post('coupons/validate', payload)
  return response
}

/**
 *
 * @returns credits
 */
export const getCredits = async () => {
  const response = await axios.get(`tenants/credits`)
  return response
}

export const getLastPurchasedPlan = async () => {
  const response = await axios.get(`subscriptions/recent-purchase-plan`)
  return response
}

export const cancelSubscription = async (subscriptionId) => {
  const response = await axios.put(`subscriptions/cancel/${subscriptionId}`)
  return response
}

export const fetchAllInvoice = async () => {
  const response = await axios.get('/invoices')
  return response
}

export const downloadInvoice = async (invoiceId) => {
  const response = await axios.get(`/invoices/generate/${invoiceId}`, {
    responseType: 'blob'
  })
  return response
}

export const fetchCreditsHistory = async (payload, contestBreakdown) => {
  const response = await axios.post(
    `features/history?contestBreakdown=${contestBreakdown}`,
    payload
  )
  return response
}

export const fetchReClaimableCandidate = async (payload) => {
  const respone = await axios.post('features/re-claimable-candidates', payload)
  return respone
}

export const reClaimCredits = async (attemptId) => {
  const response = await axios.post(`features/re-claim?attemptId=${attemptId}`)
  return response
}
